import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateRestockSessionMutationVariables = Types.Exact<{
  input: Types.CreateRestockSessionInput;
}>;


export type CreateRestockSessionMutation = { __typename?: 'Mutation', createRestockSession: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type StartRestockSessionCreationMutationVariables = Types.Exact<{
  input: Types.StartRestockSessionCreationInput;
}>;


export type StartRestockSessionCreationMutation = { __typename?: 'Mutation', startRestockSessionCreation: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type UpdateRestockSessionMutationVariables = Types.Exact<{
  input: Types.UpdateRestockSessionInput;
}>;


export type UpdateRestockSessionMutation = { __typename?: 'Mutation', updateRestockSession: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SubmitRestockSessionMutationVariables = Types.Exact<{
  input: Types.SubmitRestockSessionInput;
}>;


export type SubmitRestockSessionMutation = { __typename?: 'Mutation', submitRestockSession: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SynchronizeRestockSessionMutationVariables = Types.Exact<{
  input: Types.SynchronizeRestockSessionInput;
}>;


export type SynchronizeRestockSessionMutation = { __typename?: 'Mutation', synchronizeRestockSession: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CancelRestockSessionMutationVariables = Types.Exact<{
  input: Types.CancelRestockSessionInput;
}>;


export type CancelRestockSessionMutation = { __typename?: 'Mutation', cancelRestockSession: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type DeleteRestockSessionMutationVariables = Types.Exact<{
  input: Types.DeleteRestockSessionInput;
}>;


export type DeleteRestockSessionMutation = { __typename?: 'Mutation', deleteRestockSession: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RestockOrderItemDeltaFieldsFragment = { __typename?: 'RestockOrderItemDelta', itemId: string, customerLocationId: string, orderQuantity: number, achievableQuantity: number, demandQuantity: number, hasOverrides: boolean, previousOrderQuantity?: number | null };

export type OverrideRestockSessionOrderQuantitiesMutationVariables = Types.Exact<{
  input: Types.OverrideRestockSessionOrderQuantitiesInput;
}>;


export type OverrideRestockSessionOrderQuantitiesMutation = { __typename?: 'Mutation', overrideRestockSessionOrderQuantities: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, updatedRows?: Array<{ __typename?: 'RestockOrderItemDelta', itemId: string, customerLocationId: string, orderQuantity: number, achievableQuantity: number, demandQuantity: number, hasOverrides: boolean, previousOrderQuantity?: number | null }> | null } };

export type SetRestockSessionOrderQuantitiesMutationVariables = Types.Exact<{
  input: Types.SetRestockSessionOrderQuantitiesInput;
}>;


export type SetRestockSessionOrderQuantitiesMutation = { __typename?: 'Mutation', setRestockSessionOrderQuantities: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, updatedRows?: Array<{ __typename?: 'RestockOrderItemDelta', itemId: string, customerLocationId: string, orderQuantity: number, achievableQuantity: number, demandQuantity: number, hasOverrides: boolean, previousOrderQuantity?: number | null }> | null } };

export type RoundRestockSessionOrderQuantityToFullCartMutationVariables = Types.Exact<{
  input: Types.RoundRestockSessionOrderQuantityToFullCartInput;
}>;


export type RoundRestockSessionOrderQuantityToFullCartMutation = { __typename?: 'Mutation', roundRestockSessionOrderQuantityToFullCart: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, updatedRows?: Array<{ __typename?: 'RestockOrderItemDelta', itemId: string, customerLocationId: string, orderQuantity: number, achievableQuantity: number, demandQuantity: number, hasOverrides: boolean, previousOrderQuantity?: number | null }> | null } };

export type UndoRestockSessionOrderQuantityOverrideMutationVariables = Types.Exact<{
  input: Types.UndoRestockSessionOrderQuantityOverrideInput;
}>;


export type UndoRestockSessionOrderQuantityOverrideMutation = { __typename?: 'Mutation', undoRestockSessionOrderQuantityOverride: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null, updatedRows?: Array<{ __typename?: 'RestockOrderItemDelta', itemId: string, customerLocationId: string, orderQuantity: number, achievableQuantity: number, demandQuantity: number, hasOverrides: boolean, previousOrderQuantity?: number | null }> | null } };

export type UpdateRestockSessionReserveRulesMutationVariables = Types.Exact<{
  input: Types.UpdateRestockSessionReserveRulesInput;
}>;


export type UpdateRestockSessionReserveRulesMutation = { __typename?: 'Mutation', updateRestockSessionReserveRules: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RequestRestockCalculationMutationVariables = Types.Exact<{
  input: Types.RequestRestockCalculationInput;
}>;


export type RequestRestockCalculationMutation = { __typename?: 'Mutation', requestRestockCalculation: { __typename?: 'RestockSessionPayload', result?: string | null, requestId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AutoAllocateRestockSessionOrderQuantitiesMutationVariables = Types.Exact<{
  input: Types.AutoAllocateRestockSessionOrderQuantitiesInput;
}>;


export type AutoAllocateRestockSessionOrderQuantitiesMutation = { __typename?: 'Mutation', autoAllocateRestockSessionOrderQuantities: { __typename?: 'RestockSessionPayload', result?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export const RestockOrderItemDeltaFieldsFragmentDoc = new TypedDocumentString(`
    fragment RestockOrderItemDeltaFields on RestockOrderItemDelta {
  itemId
  customerLocationId
  orderQuantity
  achievableQuantity
  demandQuantity
  hasOverrides
  previousOrderQuantity
}
    `, {"fragmentName":"RestockOrderItemDeltaFields"});
export const CreateRestockSessionDocument = new TypedDocumentString(`
    mutation CreateRestockSession($input: CreateRestockSessionInput!) {
  createRestockSession(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const StartRestockSessionCreationDocument = new TypedDocumentString(`
    mutation StartRestockSessionCreation($input: StartRestockSessionCreationInput!) {
  startRestockSessionCreation(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const UpdateRestockSessionDocument = new TypedDocumentString(`
    mutation UpdateRestockSession($input: UpdateRestockSessionInput!) {
  updateRestockSession(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const SubmitRestockSessionDocument = new TypedDocumentString(`
    mutation SubmitRestockSession($input: SubmitRestockSessionInput!) {
  submitRestockSession(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const SynchronizeRestockSessionDocument = new TypedDocumentString(`
    mutation SynchronizeRestockSession($input: SynchronizeRestockSessionInput!) {
  synchronizeRestockSession(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const CancelRestockSessionDocument = new TypedDocumentString(`
    mutation CancelRestockSession($input: CancelRestockSessionInput!) {
  cancelRestockSession(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const DeleteRestockSessionDocument = new TypedDocumentString(`
    mutation DeleteRestockSession($input: DeleteRestockSessionInput!) {
  deleteRestockSession(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const OverrideRestockSessionOrderQuantitiesDocument = new TypedDocumentString(`
    mutation OverrideRestockSessionOrderQuantities($input: OverrideRestockSessionOrderQuantitiesInput!) {
  overrideRestockSessionOrderQuantities(input: $input) {
    result
    errors {
      code
      message
    }
    updatedRows {
      ...RestockOrderItemDeltaFields
    }
  }
}
    fragment RestockOrderItemDeltaFields on RestockOrderItemDelta {
  itemId
  customerLocationId
  orderQuantity
  achievableQuantity
  demandQuantity
  hasOverrides
  previousOrderQuantity
}`);
export const SetRestockSessionOrderQuantitiesDocument = new TypedDocumentString(`
    mutation SetRestockSessionOrderQuantities($input: SetRestockSessionOrderQuantitiesInput!) {
  setRestockSessionOrderQuantities(input: $input) {
    result
    errors {
      code
      message
    }
    updatedRows {
      ...RestockOrderItemDeltaFields
    }
  }
}
    fragment RestockOrderItemDeltaFields on RestockOrderItemDelta {
  itemId
  customerLocationId
  orderQuantity
  achievableQuantity
  demandQuantity
  hasOverrides
  previousOrderQuantity
}`);
export const RoundRestockSessionOrderQuantityToFullCartDocument = new TypedDocumentString(`
    mutation RoundRestockSessionOrderQuantityToFullCart($input: RoundRestockSessionOrderQuantityToFullCartInput!) {
  roundRestockSessionOrderQuantityToFullCart(input: $input) {
    result
    errors {
      code
      message
    }
    updatedRows {
      ...RestockOrderItemDeltaFields
    }
  }
}
    fragment RestockOrderItemDeltaFields on RestockOrderItemDelta {
  itemId
  customerLocationId
  orderQuantity
  achievableQuantity
  demandQuantity
  hasOverrides
  previousOrderQuantity
}`);
export const UndoRestockSessionOrderQuantityOverrideDocument = new TypedDocumentString(`
    mutation UndoRestockSessionOrderQuantityOverride($input: UndoRestockSessionOrderQuantityOverrideInput!) {
  undoRestockSessionOrderQuantityOverride(input: $input) {
    result
    errors {
      code
      message
    }
    updatedRows {
      ...RestockOrderItemDeltaFields
    }
  }
}
    fragment RestockOrderItemDeltaFields on RestockOrderItemDelta {
  itemId
  customerLocationId
  orderQuantity
  achievableQuantity
  demandQuantity
  hasOverrides
  previousOrderQuantity
}`);
export const UpdateRestockSessionReserveRulesDocument = new TypedDocumentString(`
    mutation UpdateRestockSessionReserveRules($input: UpdateRestockSessionReserveRulesInput!) {
  updateRestockSessionReserveRules(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
export const RequestRestockCalculationDocument = new TypedDocumentString(`
    mutation RequestRestockCalculation($input: RequestRestockCalculationInput!) {
  requestRestockCalculation(input: $input) {
    result
    errors {
      code
      message
    }
    requestId
  }
}
    `);
export const AutoAllocateRestockSessionOrderQuantitiesDocument = new TypedDocumentString(`
    mutation AutoAllocateRestockSessionOrderQuantities($input: AutoAllocateRestockSessionOrderQuantitiesInput!) {
  autoAllocateRestockSessionOrderQuantities(input: $input) {
    result
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateRestockSession: build.mutation<CreateRestockSessionMutation, CreateRestockSessionMutationVariables>({
      query: (variables) => ({ document: CreateRestockSessionDocument, variables })
    }),
    StartRestockSessionCreation: build.mutation<StartRestockSessionCreationMutation, StartRestockSessionCreationMutationVariables>({
      query: (variables) => ({ document: StartRestockSessionCreationDocument, variables })
    }),
    UpdateRestockSession: build.mutation<UpdateRestockSessionMutation, UpdateRestockSessionMutationVariables>({
      query: (variables) => ({ document: UpdateRestockSessionDocument, variables })
    }),
    SubmitRestockSession: build.mutation<SubmitRestockSessionMutation, SubmitRestockSessionMutationVariables>({
      query: (variables) => ({ document: SubmitRestockSessionDocument, variables })
    }),
    SynchronizeRestockSession: build.mutation<SynchronizeRestockSessionMutation, SynchronizeRestockSessionMutationVariables>({
      query: (variables) => ({ document: SynchronizeRestockSessionDocument, variables })
    }),
    CancelRestockSession: build.mutation<CancelRestockSessionMutation, CancelRestockSessionMutationVariables>({
      query: (variables) => ({ document: CancelRestockSessionDocument, variables })
    }),
    DeleteRestockSession: build.mutation<DeleteRestockSessionMutation, DeleteRestockSessionMutationVariables>({
      query: (variables) => ({ document: DeleteRestockSessionDocument, variables })
    }),
    OverrideRestockSessionOrderQuantities: build.mutation<OverrideRestockSessionOrderQuantitiesMutation, OverrideRestockSessionOrderQuantitiesMutationVariables>({
      query: (variables) => ({ document: OverrideRestockSessionOrderQuantitiesDocument, variables })
    }),
    SetRestockSessionOrderQuantities: build.mutation<SetRestockSessionOrderQuantitiesMutation, SetRestockSessionOrderQuantitiesMutationVariables>({
      query: (variables) => ({ document: SetRestockSessionOrderQuantitiesDocument, variables })
    }),
    RoundRestockSessionOrderQuantityToFullCart: build.mutation<RoundRestockSessionOrderQuantityToFullCartMutation, RoundRestockSessionOrderQuantityToFullCartMutationVariables>({
      query: (variables) => ({ document: RoundRestockSessionOrderQuantityToFullCartDocument, variables })
    }),
    UndoRestockSessionOrderQuantityOverride: build.mutation<UndoRestockSessionOrderQuantityOverrideMutation, UndoRestockSessionOrderQuantityOverrideMutationVariables>({
      query: (variables) => ({ document: UndoRestockSessionOrderQuantityOverrideDocument, variables })
    }),
    UpdateRestockSessionReserveRules: build.mutation<UpdateRestockSessionReserveRulesMutation, UpdateRestockSessionReserveRulesMutationVariables>({
      query: (variables) => ({ document: UpdateRestockSessionReserveRulesDocument, variables })
    }),
    RequestRestockCalculation: build.mutation<RequestRestockCalculationMutation, RequestRestockCalculationMutationVariables>({
      query: (variables) => ({ document: RequestRestockCalculationDocument, variables })
    }),
    AutoAllocateRestockSessionOrderQuantities: build.mutation<AutoAllocateRestockSessionOrderQuantitiesMutation, AutoAllocateRestockSessionOrderQuantitiesMutationVariables>({
      query: (variables) => ({ document: AutoAllocateRestockSessionOrderQuantitiesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateRestockSessionMutation, useStartRestockSessionCreationMutation, useUpdateRestockSessionMutation, useSubmitRestockSessionMutation, useSynchronizeRestockSessionMutation, useCancelRestockSessionMutation, useDeleteRestockSessionMutation, useOverrideRestockSessionOrderQuantitiesMutation, useSetRestockSessionOrderQuantitiesMutation, useRoundRestockSessionOrderQuantityToFullCartMutation, useUndoRestockSessionOrderQuantityOverrideMutation, useUpdateRestockSessionReserveRulesMutation, useRequestRestockCalculationMutation, useAutoAllocateRestockSessionOrderQuantitiesMutation } = injectedRtkApi;
